import React from 'react';
import { Sparkles } from 'lucide-react';

export function AboutPage() {
  const team = [
    { name: "Elena", role: "Creative Director", image: "/first-womn.png" }, // Girl 1
    { name: "Michael", role: "Senior Stylist", image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=600&auto=format&fit=crop" }, // Boy 1
    { name: "Sophia", role: "Color Specialist", image: "/2nd-woman.png" }, // Girl 2
    { name: "David", role: "Hair Expert", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=600&auto=format&fit=crop" }, // Boy 2
    { name: "Isabella", role: "Nail Artist", image: "/3rd-womn.png" }, // Girl 3
    { name: "James", role: "Aesthetician", image: "https://images.unsplash.com/photo-1618077360395-f3068be8e001?q=80&w=600&auto=format&fit=crop" }, // Boy 3
    { name: "Olivia", role: "Lash Technician", image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=600&auto=format&fit=crop" }, // Girl 4
    { name: "Emma", role: "Makeup Artist", image: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?q=80&w=600&auto=format&fit=crop" } // Girl 5
  ];

  return (
    <div className="bg-stone-50 min-h-screen pt-32 pb-24 px-6 relative z-10">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-serif text-5xl md:text-7xl text-mier font-light mb-12 text-center fade-in-up">About MIER Beauty Lounge</h1>
        <div className="w-px h-12 bg-mier-light/30 mx-auto mb-12 scale-y-animation"></div>
        <div className="space-y-12 text-lg text-stone-600 leading-relaxed font-light fade-in-up">
          <p>
            Welcome to MIER Beauty Lounge, a luxury ladies salon in Abu Dhabi located at Aloft Hotel Ground Floor, Al Rawdah W59 01, near ADNEC. We specialize in refined hair, nail, lash, brow, skincare, mesotherapy, and bridal beauty services for women seeking premium care in a calm setting.
          </p>
          <p>
            Our sanctuary is designed to elevate everyday routines into luxurious rituals. From the moment you step through our doors, you are welcomed into a serene salon experience shaped around meticulous technique, thoughtful service, and personalized results for Abu Dhabi clients, hotel guests, and ADNEC visitors alike.
          </p>
          <p>
            Experience the intersection of luxury and well-being at MIER, where every detail is curated to deliver trusted salon care in Al Rawdah, whether you are booking balayage, keratin, gel nails, mesotherapy, lash extensions, or bridal hair and makeup.
          </p>
        </div>
        <div className="mt-20 flex justify-center text-mier-light opacity-50 fade-in-up">
          <Sparkles className="w-6 h-6" />
        </div>
        <div className="mt-16 grid md:grid-cols-3 gap-4 fade-in-up">
          {[
            'Aloft Hotel Ground Floor, Al Rawdah W59 01',
            'Close to ADNEC and Abu Dhabi hotels',
            'Open daily for luxury salon appointments',
          ].map((item) => (
            <div key={item} className="border border-mier/10 bg-white px-6 py-5 text-center text-[11px] uppercase tracking-[0.18em] text-mier-light">
              {item}
            </div>
          ))}
        </div>
      </div>
      
      {/* Team Section */}
      <div className="max-w-6xl mx-auto mt-32 border-t border-mier-light/20 pt-32">
        <div className="text-center mb-16 fade-in-up">
          <h2 className="font-serif text-4xl md:text-5xl text-mier font-light mb-6">Our Artisans</h2>
          <p className="text-xs uppercase tracking-[0.2em] text-mier-light">Masters of their craft</p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
          {team.map((member, i) => (
            <div key={i} className="group fade-in-up">
              <div className="aspect-[3/4] overflow-hidden mb-6 bg-stone-200">
                <img 
                  src={member.image} 
                  alt={`${member.role} at MIER Beauty Lounge Abu Dhabi`} 
                  loading="lazy"
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 ease-in-out group-hover:scale-105" 
                />
              </div>
              <h3 className="font-serif text-xl tracking-wide text-mier mb-1">{member.name}</h3>
              <p className="text-[10px] uppercase tracking-[0.2em] text-mier-light">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
